import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { initAnalytics } from "@/lib/analytics";

import Navbar from "@/components/Navbar";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import StatSection from "@/components/StatSection";
import AboutCoach from "@/components/AboutCoach";
import CredibilityBar from "@/components/CredibilityBar";
import ManifestoSection from "@/components/ManifestoSection";
import ServicesGrid from "@/components/ServicesGrid";
import QuizCTA from "@/components/QuizCTA";
import BookingSection from "@/components/BookingSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/Admin";
import QuizPage from "@/pages/Quiz";

const Landing = () => {
  useEffect(() => {
    initAnalytics();
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" data-testid="landing-page">
      <Navbar />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <StatSection />
        <AboutCoach />
        <CredibilityBar />
        <ManifestoSection />
        <ServicesGrid />
        <QuizCTA />
        <BookingSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/quiz" element={<QuizPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
